import { TypedEvent, ITypedEvent } from "../TypedEvent";
import { DataFrame, IDataFrame } from "../DataFrame";
import { IDIService } from "../IDIService";

export interface IExalusConnectionService extends IDIService {
    SetServersBrokerAddress(address: string): void;
    SetDefaultPacketsBrokerAddress(address: string): void;
    GetServerAddressAsync(): Promise<string | null>;
    GetConnectedBrokerInfoAsync(timeoutMs?: number | null): Promise<BrokerInfo>;
    ConnectAsync(address: string): Promise<ConnectionResult>;
    AuthorizeAsync(authorizationInfo: AuthorizationInfo): Promise<boolean>;
    ConnectAndAuthorizeAsync(authorizationInfo: AuthorizationInfo): Promise<ConnectionResult>;
    DisconnectAsync(): Promise<void>;
    IsConnected(): boolean;
    EnablePacketsLogging(): void;
    DisablePacketsLogging(): void;
    SendAsync(dataFrame: IDataFrame<any>): Promise<boolean>;
    SendAndWaitForResponseAsync<T>(dataFrame: IDataFrame<any>, timeout: number, useCache: boolean): Promise<IDataFrame<T>>;
    SendAndWaitForResponseAsync<T>(dataFrame: IDataFrame<any>, timeout: number, useCache: boolean, logTransmission: boolean): Promise<IDataFrame<T>>;
    SendAndHandleResponseAsync<T>(dataFrame: IDataFrame<any>, timeout: number, dataHandler: (result: IDataFrame<T>) => void, logTransmission: boolean): Promise<void>;
    SendAndHandleStreamAsync<T>(dataFrame: IDataFrame<any>, streamHandler: StreamHandler<T>, logTransmission: boolean): Promise<void>
    OnDataReceivedEvent(): ITypedEvent<IDataFrame<any>>;
    /// <summary>
    /// Subscribe to a specific resource. Returns a function that can be called to unsubscribe.
    /// </summary>
    SubscribeTo<T>(resourceId: string, handler: { (data: IDataFrame<T>): void }): () => void;
    OnErrorOccuredEvent(): ITypedEvent<[sender: string, data: string]>;
    OnConnectionStateChangedEvent(): ITypedEvent<ConnectionState>;
    GetAuthorizationInfo(): AuthorizationInfo | null;
}

export class AuthorizationInfo {
    public constructor(public serialNumber: string, public pin: string) {
        this.SerialNumber = serialNumber;
        this.PIN = pin;
    }

    public SerialNumber: string;
    public PIN: string;
}

export enum ConnectionType {
    ByCloud = 0,
    LocalNetwork = 1,
    P2P = 2,
}

export enum ConnectionResult {
    FailedToConnect = 0,
    AuthorizationFailed = 1,
    FailedToConnectToServer = 2,
    Connected = 3,
    ControllerIsNotConnected = 4
}

export enum ConnectionState {
    Disconnected = 0,
    Connecting = 1,
    Connected = 3,
    Disconnecting = 4,
    Failed = 5,
    Reconnecting = 6,
    ConnectedAndAuthorized = 7,
}

export class BrokerInfo {
    constructor(
        public BrokerUrl: string,
        public BrokerControllerUrl: string | undefined,
        public Env: BrokerEnvironment = BrokerEnvironment.Production
    ) {}
}

export enum BrokerEnvironment {
    Production = 0,
    Development = 1,
    Local = 2
}

export type StreamHandler<T> = {
    Next: (item: T) => void;
    Complete: () => void;
    Error: (err: any) => void;
}

export class StreamError extends Error {
    constructor(message: string) {
        super(message);
        this.name = "StreamError";
    }
}